import React, { useEffect, useRef, useState } from 'react';
import './USPSection.scss';

const USPSection: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section className="usp-section">
      <div className={`usp-content ${isVisible ? 'visible' : ''}`} ref={sectionRef}>
        <h2>Why Choose SGT Docket Rocket?</h2>
        <p>
          Unlike the Connecticut Judicial Website's notification system, which only sends limited updates 
          once per day, SGT Docket Rocket provides detailed and timely information that keeps you informed 
          and ahead of the game. Whether you're managing multiple cases or focusing on a single matter, 
          SGT Docket Rocket ensures you never miss an important development. Stay informed, save time, 
          and gain a competitive edge with SGT Docket Rocket.
        </p>
      </div>
    </section>
  );
};

export default USPSection;

